import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { FormControlChildAbstract } from '~/component/form/abstracts/control-child.abstract';

import { InputStyleEnum } from '~/component/form/input/enums/style.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-form-autocomplete-trigger',
  templateUrl: './trigger.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormAutocompleteTriggerComponent,
      multi: true,
    },
  ],
})
export class FormAutocompleteTriggerComponent extends FormControlChildAbstract<string> {
  @Input() public ariaLabel: string;
  @Input() public inputIcon: VtmnPlayIconTypeEnum;
  @Input() public inputStyle: InputStyleEnum;
  @Input() public isClearable = false;
  @Input() public isOpen = false;
  @Input() public placeholder = '';
  @Input() public triggerId: string;

  @Output() public readonly clearInput = new EventEmitter<Event>();
  @Output() public readonly focusInput = new EventEmitter<void>();

  public readonly iconType = VtmnPlayIconTypeEnum;

  public emitValue($event: string): void {
    this.value = $event;
  }
}
